import {TierSubscriptionInfoRepresentation} from '@aztrix/sdk';

export interface TierStateModel {
  currentTier: TierSubscriptionInfoRepresentation.CurrentTierEnum | undefined;
}

export const defaults: TierStateModel = {
  currentTier: undefined,
};
